<style scoped>
    #index_pc_bj{
        width: 100%;
        height: 720px;
        background-size:cover;
        overflow: hidden;
        background-image: url(../../assets/error404.gif);
        background-position:center center;
        background-repeat: no-repeat;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
    }
</style>
<template>
    <div class="index">
        <div id="index_pc_bj">

        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        methods: {

        }
    };
</script>